import Preset from './_default';

export default class Brooklyn extends Preset {
    name = 'Debut';

    // override the default Preset here
}
